var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-select', _vm._b({
    class: "human-resource-sort-".concat(_vm.className),
    attrs: {
      "items": _vm.sortItems,
      "menuProps": {
        attach: ".human-resource-sort-".concat(_vm.className)
      }
    },
    on: {
      "change": _vm.emit
    },
    model: {
      value: _vm.query.sort,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "sort", $$v);
      },
      expression: "query.sort"
    }
  }, 'v-select', _vm.attrs_input, false));
}
var staticRenderFns = []

export { render, staticRenderFns }